import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SiteTheme, ThemeService } from 'src/app/core/services/theme/theme.service';

interface ThemeOption {
    value: SiteTheme;
    label: string;
    /** material icons ligature (the site serves the full font) */
    icon: string;
}

/**
 * The light / dark / system control, rendered by the header menu and the footer (standalone,
 * imported by EsiFactoryModule).
 */
@Component({
    selector: 'theme-switch',
    standalone: true,
    templateUrl: './theme-switch.component.html',
    styleUrls: ['./theme-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitchComponent {
    private readonly _theme = inject(ThemeService);

    public readonly current = this._theme.preference;
    public readonly groupLabel = $localize`:@@theme-menu-title:תצוגה`;
    public readonly options: ThemeOption[] = [
        { value: 'light', label: $localize`:@@theme-light:בהיר`, icon: 'light_mode' },
        { value: 'dark', label: $localize`:@@theme-dark:כהה`, icon: 'dark_mode' },
        { value: 'system', label: $localize`:@@theme-system:לפי המערכת`, icon: 'brightness_auto' },
    ];

    public select(value: SiteTheme): void {
        this._theme.set(value);
    }
}
